<template>
  <div class="box">
    <div class="fail">参数失效， <a :href="linkUrl">点击继续操作</a>
    </div>
  </div>
</template>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default {
    data () {
      return {
        type: 'qq',
        CONF: CONF,
        isMobile: false,
        linkUrl: CONF.APIList.QQLogin
      }
    },
    created () {
      this.isMobile = server.isMobile()
      if (this.$route.query.type) {
        this.type = this.$route.query.type
      }
      if (this.type === 'wx') {
        this.linkUrl = CONF.APIList.WXLogin + '&isMobile=' + this.isMobile
      }
    }
  }
</script>
<style  scoped>
  .box{
    display: table;
    text-align: center;
    width: 100%;height: 100%;
  }
  .fail{color: #000000;display: table-cell;vertical-align: middle;width: 100%;height: 100%;}
  .fail a{text-decoration: underline;color: #097ce0;}
</style>



// WEBPACK FOOTER //
// LoginFail.vue?3dc63bc2